import { Center, Container, Paper } from '@mantine/core'
import { createFileRoute, redirect } from '@tanstack/react-router'
import Logo from 'common/Logo'
import LoginForm from 'components/auth/LoginForm'
import { accountQuery } from 'hooks/auth'
import posthog from 'posthog-js'
import { useEffect } from 'react'
import { Account } from 'types/auth'

export const Route = createFileRoute('/login')({
  beforeLoad: async ({ context: { queryClient } }) => {
    try {
      await queryClient.fetchQuery<Account>({ ...accountQuery, retry: 0 })
      throw redirect({
        to: '/',
      })
    } catch (error: any) {
      if (error?.to === '/') {
        throw redirect({
          to: '/',
        })
      }
    }
  },
  component: LoginPage,
})

function LoginPage() {
  useEffect(() => {
    posthog.reset()
  }, [])
  return (
    <Center h="100%">
      <Container w={420} my={40}>
        <Paper withBorder shadow="md" p={30} radius="md">
          <Logo size="lg" mb="md" />
          <LoginForm />
        </Paper>
      </Container>
    </Center>
  )
}
